import { useCallback, useRef } from 'react';

export const useInitialStateConsumptionLedger = () => {
    const consumedInitialPathsRef = useRef<Set<string>>(new Set<string>());

    const isInitialPathConsumed = useCallback((path: string): boolean => {
        return consumedInitialPathsRef.current.has(path);
    }, []);

    const consumeInitialPath = useCallback((path: string): void => {
        consumedInitialPathsRef.current.add(path);
    }, []);

    const getConsumedInitialPaths = useCallback((): Set<string> => {
        return consumedInitialPathsRef.current;
    }, []);

    return {
        isInitialPathConsumed,
        consumeInitialPath,
        getConsumedInitialPaths
    };
};
